"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { TMSLoad } from "./tms_load";
export class LoadState {
  constructor(loadState) {
    __publicField(this, "loadState");
    __publicField(this, "load");
    this.loadState = loadState;
    this.load = new TMSLoad(this.loadState.load);
  }
}
